import { FormContainer } from 'components/FormContainer';
import { EaeuInfo } from 'api/eaeu/types';
import { ModalContent } from './components/ModalContent';

type SelectTransactionsModalProps = {
  onClose: () => void;
  onSubmit: (transactionIds: string[]) => void;
  transactions: EaeuInfo[];
};

export const SelectTransactionsModal = ({
  onClose,
  onSubmit,
  transactions,
}: SelectTransactionsModalProps) => (
  <FormContainer>
    <ModalContent onClose={onClose} onSubmit={onSubmit} transactions={transactions} />
  </FormContainer>
);
